import { InterceptorClient } from "../../interceptor/interceptorClient";
import { COUNTRIES } from "../../constants/common/common";
import { ADD_ONS_TO_CART, GET_ADD_ON_INFO, GET_ADD_ON_INFO_NEW } from "./constant";

const baseURL = process.env.NEXT_PUBLIC_BASE_URL;
/**
 * Method to fetch deliveryDates on client side
 *
 * @param {string} contentURL page content slug
 * @returns {string} returns html file data
 */
export async function fetchAddOnInfo(props) {
  try {
    const res = await InterceptorClient.getFTSInstance(baseURL).get(`${GET_ADD_ON_INFO(props)}`, false, null, {
      "x-api-version": "v1.4",
    });
    return res;
  } catch (err) {
    throw new Error(err.message);
  }
}

/**
 * Method to fetch deliveryDates on client side
 *
 * @param {string} contentURL page content slug
 * @returns {string} returns html file data
 */
export async function fetchAddOnInfoNew(props) {
  try {
    const isDomestic = props?.FNP_CURRENT_CATALOG_ID === COUNTRIES.INDIA;
    const res = await InterceptorClient.getFTSInstance(baseURL).get(
      `${GET_ADD_ON_INFO_NEW(props)}`,
      false,
      null,
      isDomestic ? { "x-api-version": "v1.4" } : {},
    );
    return res;
  } catch (err) {
    throw new Error(err.message);
  }
}

/**
 * Method to add an add-on to the shopping cart on the client side
 *
 * @param {Object} payload - The data required to add the add-on to the cart.
 * @returns {Object} Returns the response from the server after adding the add-on.
 */
export async function addAddonToCart(payload) {
  try {
    const isDomestic = !new URLSearchParams(payload).has("shippingMethodId");
    const res = await InterceptorClient.getFTSInstance(baseURL).post(
      payload,
      ADD_ONS_TO_CART(),
      false,
      isDomestic ? { "x-api-version": "v1.4" } : {},
    );
    return res;
  } catch (err) {
    throw new Error(err.message);
  }
}
